import { defaultSearchVerticalRoutes } from 'constants/search'
import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router'
import useGlobalSearchVerticals from './useGlobalSearchVerticals'

export default function useCurrentGlobalSearchVerticalPage(): App.SearchVertical | undefined {
  const location = useLocation()
  const searchVerticals = useGlobalSearchVerticals()
  const currentGlobalSearchVerticalPage = useMemo(() => {
    return searchVerticals.find((searchVertical) => {
      const routes = defaultSearchVerticalRoutes.get(searchVertical.vertical)
      return matchPath(location.pathname, { path: routes })
    })?.vertical
  }, [location.pathname, searchVerticals])

  return currentGlobalSearchVerticalPage
}
